export default __webpack_public_path__ + "files/media/SF-Ham-S.1eec33ac.jpg";